import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Menu,
  MenuItem,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { useSendDeviceCommand } from '../../queries';

const Actions = ({ mac }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const toggleMenuDisplay = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [action, setAction] = useState('');
  const [showError, setShowError] = useState(false);

  const { mutate, isFetching, error } = useSendDeviceCommand(mac, action, {
    onError: () => {
      setShowError(true);
    },
  });

  const errorMessage = error?.response?.data?.error ?? error?.message ?? 'An error occurred';

  useEffect(async () => {
    if (action !== '') {
      await mutate();
      setAction('');
    }
  }, [action]);

  const handleResetAppClick = () => {
    setAction('restart');
    handleClose();
  };

  const handleResetAllClick = () => {
    setAction('restart_all');
    handleClose();
  };

  const handleRebootDeviceClick = () => {
    setAction('reboot');
    handleClose();
  };

  if (isFetching) {
    return <CircularProgress size={20} />;
  }

  return (
    <div>
      {showError && (
        <Dialog open={true} onClose={() => setShowError(false)}>
          <DialogTitle>Device Command Error</DialogTitle>
          <DialogContent>
            <DialogContentText>{errorMessage}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowError(false)}>OK</Button>
          </DialogActions>
        </Dialog>
      )}
      <Box>
        <Button
          id="action-menu-button"
          aria-controls={open ? 'action-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          variant="contained"
          disableElevation
          onClick={toggleMenuDisplay}
          size="small"
          color="primary"
          endIcon={<KeyboardArrowDownIcon />}
        >
          Action
        </Button>
        <Menu
          id="action-menu"
          MenuListProps={{
            'aria-labelledby': 'action-menu-button',
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          <MenuItem onClick={handleResetAppClick} disableRipple>
            Reset App
          </MenuItem>
          <MenuItem onClick={handleResetAllClick} disableRipple>
            Reset All
          </MenuItem>
          <MenuItem onClick={handleRebootDeviceClick} disableRipple>
            Reboot Device
          </MenuItem>
        </Menu>
      </Box>
    </div>
  );
};

Actions.propTypes = {
  mac: PropTypes.string,
};

export default Actions;
